import { render, staticRenderFns } from "./TriggerBtnBestSeller.vue?vue&type=template&id=b92d8a72"
import script from "./TriggerBtnBestSeller.vue?vue&type=script&lang=js"
export * from "./TriggerBtnBestSeller.vue?vue&type=script&lang=js"
import style0 from "./TriggerBtnBestSeller.vue?vue&type=style&index=0&id=b92d8a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports